const DEFAULT_TIMEOUT = 1000

let timer
export const debounced = (fn, timeout = DEFAULT_TIMEOUT) => {
  if (timer) {
    clearTimeout(timer)
  }
  timer = setTimeout(() => {
    fn()
    timer = null
  }, timeout)
}
